import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useIntegrationRollout } from 'v2/shared/hooks/use-integration-rollout'
import { settingsService } from '../services/settings-service'
import { getSettingsQueryKeys } from '../utils/query-key-management'
import { prefetchIntegrationConnections } from './prefetcher-utils'

export const Prefetcher = () => {
  const queryClient = useQueryClient()
  const { gateway, isResolved, useAciIntegrations } = useIntegrationRollout()

  useEffect(() => {
    prefetchIntegrationConnections(queryClient, { gateway, isResolved, useAciIntegrations })
  }, [queryClient, gateway, isResolved, useAciIntegrations])

  useEffect(() => {
    queryClient.prefetchQuery({
      queryKey: getSettingsQueryKeys().users,
      meta: { silent: true },
      queryFn: async () => {
        const response = await settingsService.getUsersList({})
        return response.data
      },
    })
  }, [])

  return null
}
